import { useContext } from "react";
import { GlobalContext } from "@components/contextProvider/ContextProvider";
import { data as en } from "./en/data";
import { data as es } from "./es/data";
import { data as ru } from "./ru/data";
import { data as zh } from "./zh/data";

/**
 * Get current language
 * @name GetLang
 * @returns {string}
 */
export const GetLang = (): string => {
    const context = useContext(GlobalContext);
    const { lang } = context?.state || {};

    return lang || "en";
};

const gradeMap: Record<string, string> = {
    // Preschool
    PRE: "PRE",
    C3: "PRE",
    C4: "PRE",
    C5: "PRE",
    CF: "PRE",
    CF4: "PRE",
    CF5: "PRE",
    CH5: "PRE",
    CP3: "PRE",
    CP4: "PRE",
    CP5: "PRE",
    CT5: "PRE",
    I1: "PRE",
    I2: "PRE",
    I3: "PRE",
    P3: "PRE",
    P4: "PRE",
    P5: "PRE",
    PK: "PRE",
    UH5: "PRE",
    UP4: "PRE",
    UP5: "PRE",
    UT5: "PRE",
    // Kindergarten
    K: "K",
    "0F": "K",
    "0H": "K",
    "00": "K",
    // Grades 1-12
    FIRST: "01",
    "01": "01",
    SECOND: "02",
    "02": "02",
    THIRD: "03",
    "03": "03",
    FOURTH: "04",
    "04": "04",
    FIFTH: "05",
    "05": "05",
    SIXTH: "06",
    "06": "06",
    SEVENTH: "07",
    "07": "07",
    EIGHTH: "08",
    "08": "08",
    NINTH: "09",
    "09": "09",
    TENTH: "10",
    "10": "10",
    ELEVENTH: "11",
    "11": "11",
    TWELFTH: "12",
    "12": "12"
};

export const gradeTranslator = (grade: string | null): string => {
    if (!grade) {
        return "-";
    }
    return gradeMap[grade] ?? "-";
};

interface TProps {
    tKey: string;
    langStr?: string | null;
}

const translationData: Record<string, Record<string, React.ReactNode>> = {
    en,
    es,
    ru,
    zh
};

/**
 * Returns the translated content for a given key and language.
 * @param {string} key
 * @param {string|null} langStr
 * @returns {React.ReactNode}
 */
export const translate = (key: string, langStr: string | null = null): React.ReactNode => {
    const myLang = langStr || "en";
    const data = translationData[myLang] || en;
    return data[key] || en[key] || key;
};

/**
 * Translator engine component - use context unless a langStr is provided
 * @name T
 * @param {TProps} props
 * @returns {React.ReactNode}
 */
const T = ({ tKey, langStr = null }: TProps): React.ReactNode => {
    const context = useContext(GlobalContext);
    const contextLang = context?.state?.lang || null;
    return translate(tKey, langStr || contextLang);
};

export default T;
